module.exports = __webpack_public_path__ + "img/icon_new.034de016.png";